import { graphqlRequest } from "./graphql";

// ── Wallet Trend ──

export interface WalletTransaction {
  amount: number;
  created_at: string;
  type: string;
}

interface GetWalletTrendResponse {
  transactions: WalletTransaction[];
}

export async function getWalletTrend(
  userId: string,
  from: string,
  to: string,
  token: string
) {
  const query = `
    query GetWalletTrend($_lte: timestamptz!, $_gte: timestamptz!, $user_id: uuid!) {
      transactions: whatsub_wallet(
        where: {
          created_at: {_lte: $_lte, _gte: $_gte},
          user_id: {_eq: $user_id}
        },
        order_by: {created_at: asc}
      ) {
        amount
        created_at
        type
      }
    }
  `;
  const data = await graphqlRequest<GetWalletTrendResponse>(
    query,
    { _gte: from, _lte: to, user_id: userId },
    token
  );
  return data.transactions;
}

// ── Gift Card Purchases ──

export interface GiftCardPurchase {
  amount: number;
  discounted_amount: number;
  whatsub_service: {
    service_name: string;
    image_url: string;
  } | null;
  whatsub_plan: {
    whatsub_service: {
      service_name: string;
      image_url: string;
    };
  } | null;
}

interface GetGiftCardPurchasesResponse {
  whatsub_coupon_allocation: GiftCardPurchase[];
}

export async function getGiftCardPurchases(
  userId: string,
  from: string,
  to: string,
  token: string
) {
  const query = `
    query GetGiftCardPurchases($_gte: timestamptz!, $_lte: timestamptz!, $user_id: uuid!) {
      whatsub_coupon_allocation(
        where: {
          user_id: { _eq: $user_id }
          allocated_at: { _gte: $_gte, _lte: $_lte }
          delivery_status: { _eq: "Done" }
        }
        order_by: { allocated_at: desc }
      ) {
        amount
        discounted_amount
        whatsub_service {
          service_name
          image_url
        }
        whatsub_plan {
          whatsub_service {
            service_name
            image_url
          }
        }
      }
    }
  `;
  const data = await graphqlRequest<GetGiftCardPurchasesResponse>(
    query,
    { _gte: from, _lte: to, user_id: userId },
    token
  );
  return data.whatsub_coupon_allocation;
}

// ── Helpers ──

export function getServiceName(purchase: GiftCardPurchase): string {
  return (
    purchase.whatsub_service?.service_name ??
    purchase.whatsub_plan?.whatsub_service?.service_name ??
    "Unknown"
  );
}

export function getServiceImage(purchase: GiftCardPurchase): string {
  return (
    purchase.whatsub_service?.image_url ??
    purchase.whatsub_plan?.whatsub_service?.image_url ??
    ""
  );
}
